import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import {ModuleWithProviders} from '@angular/core';
import { MyServicesComponent } from './my-services/my-services.component';
import { ContactsComponent } from './contacts/contacts.component';
import { ActiveComponent } from './active/active.component';



export const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'participar',
    component: ActiveComponent
  },
  {
    path: 'resultado',
    component: ActiveComponent
  },
  // {
  //   path: 'servicios',
  //   component: MyServicesComponent
  // },
  // {
  //   path: 'nosotros',
  //   component: AppComponent
  // },
  // {
  //   path: 'contacto',
  //   component: ContactsComponent
  // },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/app-routing.module.ts